@if (!!option) {
  <div
    class="group relative mb-px snap-end rounded-[4px] py-[8px] font-medium leading-[17px] hover:bg-aux-blue-light-50"
    [ngClass]="{
      'cursor-pointer': !option.disabled,
      'cursor-not-allowed': option.disabled,
      'bg-aux-blue-light-50': isAddMode || isEditMode,
      'selected-option': isSelected && !isAddMode && !isEditMode,
    }"
  >
    <div class="relative flex items-center">
      @if (isEditCategoryBtnVisible()) {
        <div
          class="absolute left-0.5 flex cursor-pointer items-center opacity-0 group-hover:opacity-100"
        >
          <aux-icon name="Pencil" class="text-aux-blue" (click)="onEditMode()" />
        </div>
      }

      @if (!isEditMode) {
        <div
          class="flex-grow truncate"
          [ngStyle]="{
            paddingLeft: option.indent * 13 + 'px',
          }"
          [auxTooltip]="
            option.disabledTooltip
              ? option.disabledTooltip
              : opt.offsetWidth < opt.scrollWidth
                ? option.name
                : ''
          "
          [auxTooltipPositions]="tooltipPositions"
          #opt
          (click)="onDropdownSelected()"
        >
          {{ option.name }}
        </div>
      }

      @if (isAddCategoryBtnVisible()) {
        <div class="flex cursor-pointer items-center px-1.5 opacity-0 group-hover:opacity-100">
          <aux-icon name="Plus" class="text-aux-blue" (click)="onAddMode()" />
        </div>
      }
    </div>

    @if (isAddMode || isEditMode) {
      <div
        class="px-1.5"
        [ngClass]="{
          'pt-[8px]': isAddMode,
        }"
      >
        <input
          #categoryInput
          id="categoryNameControl"
          [formControl]="categoryNameControl"
          type="text"
          [ngStyle]="{
            paddingLeft: (option.indent + (isAddMode ? 1 : 0)) * 13 + 'px',
          }"
          class="inline-category-control placeholder-italic w-full border-0 font-normal outline-0 focus:shadow-none focus:shadow-transparent"
          placeholder="New Category Name"
          (keyup.enter)="updateCategoryList()"
          (keyup.tab)="updateCategoryList()"
        />
      </div>
    }

    @if (isAddMode || isEditMode) {
      <div
        class="absolute right-0 top-full z-[1] flex cursor-pointer bg-aux-blue-light-50 leading-none shadow-sm"
      >
        <div
          class="p-0.5"
          [ngClass]="{
            'opacity-30': isUpdateCategoryDisabled(),
          }"
          [auxTooltip]="updateCategoryBtnTooltip()"
          (click)="updateCategoryList()"
        >
          <aux-icon name="Check" class="text-aux-green-dark" />
        </div>

        <div class="border-l p-0.5" (click)="offUpdateMode()">
          <aux-icon name="X" class="text-aux-red-dark" />
        </div>
      </div>
    }
  </div>
}
